import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const PSYCHIATRIC_FORM_INITIAL_VALUES = {
  sections: {
    psychiatric: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamPsychiatricSections = keyof typeof PSYCHIATRIC_FORM_INITIAL_VALUES.sections;
